import MastersManager from "./MastersManager";

export default MastersManager;
